module.exports = __webpack_public_path__ + "assets/img/83@3x.d199f014.png";